<template>
  <div v-if="totalPages > 1" class="flex justify-between items-center mb-4">
    <button type="button" @click="onClickPreviousPage" :disabled="isInFirstPage">
      <ChevronLeftIcon class="chevron" />
    </button>

    <div class="flex items-center">
      <div v-for="(page, index) in pages" :key="index">
        <button
          type="button"
          @click="onClickPage(page.name)"
          :disabled="page.isDisabled"
          class="pageNumber mx-4"
          :class="{ 'selected': isPageActive(page) }">
          {{ page.name }}
        </button>
      </div>
    </div>

    <button @click="onClickNextPage" :disabled="isInLastPage">
      <ChevronRightIcon class="chevron" />
    </button>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapMutations, mapState } from 'vuex'
import ChevronRightIcon from '@/components/ChevronRightIcon.vue'
import ChevronLeftIcon from '@/components/ChevronLeftIcon.vue'
// import Icon from '@/components/Icon.vue'

export default {
  name: 'Pagination',
  components: {
    ChevronRightIcon,
    ChevronLeftIcon
  },
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3
    }
  },
  data () {
    return {
      actualPage: 1
    }
  },
  computed: {
    ...mapState(['participationsFiltered', 'currentPage', 'perPage']),
    totalPages () {
      return Math.ceil(this.participationsFiltered.length / this.perPage)
    },
    pages () {
      const range = []
      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        })
      }
      return range
    },
    startPage () {
      // When on the first page
      if (this.currentPage === 1) {
        return 1
      }

      // When on the last page
      if (this.currentPage === this.totalPages && this.currentPage !== 2) {
        return this.totalPages - this.maxVisibleButtons + 1
      }

      // When inbetween
      return this.currentPage - 1
    },
    endPage () {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages)
    },
    isInFirstPage () {
      return this.currentPage === 1
    },
    isInLastPage () {
      return this.currentPage === this.totalPages
    }
  },
  emits: ['pagechanged'],
  methods: {
    ...mapMutations(['setCurrentPage', 'getParticipationsPaginated']),
    onClickFirstPage () {
      this.$emit('pagechanged', 1)
      this.setCurrentPage(1)
      this.getParticipationsPaginated(false)
      this.scrollToTop()
    },
    onClickPreviousPage () {
      this.$emit('pagechanged', this.currentPage - 1)
      this.setCurrentPage(this.currentPage - 1)
      this.getParticipationsPaginated(false)
      this.scrollToTop()
    },
    onClickPage (page) {
      this.$emit('pagechanged', page)
      this.setCurrentPage(page)
      this.getParticipationsPaginated(false)
      this.scrollToTop()
    },
    onClickNextPage () {
      this.$emit('pagechanged', this.currentPage + 1)
      this.setCurrentPage(this.currentPage + 1)
      this.getParticipationsPaginated(false)
      this.scrollToTop()
    },
    onClickLastPage () {
      this.$emit('pagechanged', this.totalPages)
      this.setCurrentPage(this.totalPages)
      this.getParticipationsPaginated(false)
      this.scrollToTop()
    },
    isPageActive (page) {
      return this.currentPage === page.name
    },
    scrollToTop () {
      const videolist = document.getElementById('videoList')
      videolist.scrollIntoView()
      // window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
.pageNumber {
  font-weight: 500;
  font-size: 1.125rem;
  line-height: 1.75rem;
  width: 40px;
}
.selected {
  border-color: var(--primary);
  border-radius: 0.25rem;
  border-width: 2px;
  padding: 0.25rem;
  color: var(--primary);
}
.chevron {
  color: var(--primary);
}
button:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
button:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
</style>
